export default {"src":"/_next/static/media/search-icon.16b38065.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};